import { deviceInfo } from 'lib/capacitor-init';

/**
 * Configuration globale exécutée une fois après la création de l'objet app :
 * requêtes AJAX (en-têtes, progression), surcharge Backbone.sync, clavier mobile.
 */
export default function setup( app )
{
	$.ajaxSetup({
		timeout: 1000 * 60 * 5,

		xhr: function()
		{
			var xhr = new window.XMLHttpRequest();
			app.addProgress( xhr );
			return xhr;
		}
	});

	$.ajaxPrefilter(function( options )
	{
		if( options.background )
		{
			options.xhr = function() { return new window.XMLHttpRequest(); };
		}

		options.headers = options.headers || {};

		if( deviceInfo.manufacturer && deviceInfo.model && deviceInfo.identifier )
		{
			options.headers['x-device'] = deviceInfo.manufacturer + ' - ' + deviceInfo.model + ' - ' + deviceInfo.identifier;
		}

		var token = app.getStore('settings').get('token');
		if( token )
		{
			options.headers['Authorization'] = 'Bearer ' + token;
		}
	});

	Backbone.syncXhr = Backbone.sync;

	Backbone.sync = function( method, model, options )
	{
		try
		{
			var url = _.result( model, 'url' );
		}
		catch( e )
		{
			return $.Deferred().resolve();
		}

		var xhr = Backbone.syncXhr( method, model, options );
		console.log( 'Xhr.' + method, url, 'requesting…' );
		xhr.done( function() { console.log( 'Xhr.' + method, url, 'ok', xhr.responseText.length ); } );
		xhr.fail( function( text ) { console.warn( 'Xhr.' + method, url, 'error', JSON.stringify( text ) ); } );

		return xhr;
	};

	var H = $(window).height();
	var W = $(window).width();

	$(window).on('resize', function()
	{
		var h = $(window).height();
		var w = $(window).width();

		if( w == W && h < H ) $(document.activeElement).trigger('showkbd');
		if( w == W && h > H ) $(document.activeElement).trigger('hidekbd');

		H = h;
		W = w;
	});
}
